import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ChatbotCustomSales,
  ChatbotCustomMarketing,
  ChatbotCustomLogistics,
  ChatbotCustomHealthcare,
} from "../../../app-constants";
import { Link } from "gatsby";

function Chatbotcustom() {
  return (
    <section className="chatbot_custom p-100" style={{ background: "#F8F8FB" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              AI Chatbot Development Services: Custom Bots for a Personalized
              Experience
            </h2>
            <p>
              The virtual bots we create are compatible with any platform or
              website. You can seamlessly pair them on your website’s chat
              rooms, or even internal group discussion, team meetings, social
              media messaging apps, and whole lot more important scenarios.
              Moreover, as a chatbot development company we’ve worked on
              multiple AI projects, and our chatbot developers have built
              virtual assistants for multiple industries. Whether it’s about
              resolving queries, or improving team productivity, our chatbot
              solutions can help you gain a competitive edge over others. While
              you cut more time on mundane, repetitive tasks, your team members
              can always explore more creative avenues of work and perform
              high-value duties.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={11}
            xxl={10}
            className="m-auto text-center"
          >
            <Row>
              <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                <div className="chatbot_custom_box">
                  <div className="chatbot_custom_num">
                    <h2>01</h2>
                  </div>
                  <div className="chatbot_custom_icon">
                    {ChatbotCustomSales}
                  </div>
                  <div className="chatbot_custom_head">
                    <h4>Sales</h4>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                <div className="chatbot_custom_box">
                  <div className="chatbot_custom_num">
                    <h2>02</h2>
                  </div>
                  <div className="chatbot_custom_icon">
                    {ChatbotCustomMarketing}
                  </div>
                  <div className="chatbot_custom_head">
                    <h4>Marketing</h4>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                <div className="chatbot_custom_box">
                  <div className="chatbot_custom_num">
                    <h2>03</h2>
                  </div>
                  <div className="chatbot_custom_icon">
                    {ChatbotCustomLogistics}
                  </div>
                  <div className="chatbot_custom_head">
                    <h4>Logistics & Supply Chain</h4>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                <div className="chatbot_custom_box">
                  <div className="chatbot_custom_num">
                    <h2>04</h2>
                  </div>
                  <div className="chatbot_custom_icon">
                    {ChatbotCustomHealthcare}
                  </div>
                  <div className="chatbot_custom_head">
                    <Link to="https://www.tekrevol.com/healthcare-app-development">
                      <h4>Healthcare</h4>
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Chatbotcustom;
